import Button from 'components/Button/Button'
import Court from 'components/Court'
import PageLoader from 'components/PageLoader/PageLoader'
import { Text } from 'components/Text'
import { Location } from 'models/location'
import {
  FacilitiesAddress,
  FacilitiesCourtContainer,
  FacilitiesCourtImage,
  FacilitiesCourtImageContainer,
  LocationIconContainer,
} from 'pages/Facilities/Facilities.styled'
import React, { useEffect, useState } from 'react'
import { MdLocationOn } from 'react-icons/md'
import { useParams } from 'react-router'
import { useAppDispatch, useAppState } from 'store'
import { appointmentActions } from 'store/slices/appointments/appointments.slice'
import {
  ExternalProgramContainer,
  ExternalProgramItemContainer,
} from './ExternalProgram.styled'
import { programActions } from 'store/slices/programs'
import { CLIENT_LIST_LIMIT } from 'utils/client-list-constant'
import Table from 'components/Table'
import { ProgramItem } from './components/ProgramItem/ProgramItem'
import { Input } from 'components/Input'

const ExternalProgramPage: React.FC = () => {
  const params = useParams<Location>()
  const dispatch = useAppDispatch()
  const { location, loading } = useAppState(state => state.appointments)
  const { programs, programStatus } = useAppState(state => state.programs)
  const { currentPage, totalPrograms } = useAppState(state => state.programs)
  const [searchText, setSearchText] = useState<string>('')

  useEffect(() => {
    dispatch(appointmentActions.getLocation(params ? params.locationId : ''))
  }, [])

  useEffect(() => {
    if (currentPage) {
      dispatch(
        programActions.getPrograms({
          locationId: params ? params.locationId : '',
          page: currentPage,
          discarded: false,
          limit: CLIENT_LIST_LIMIT,
          visible: true,
          search: searchText,
        })
      )
    }
  }, [currentPage, searchText])

  const handleRedirect = () => {
    if (location?.website_url) {
      if (!location.website_url.includes('https')) {
        const newUrl = `https://${location.website_url}`
        window.open(newUrl, '_blank')
        return
      }
      if (!location.website_url.includes('http')) {
        const newUrl = `http://${location.website_url}`
        window.open(newUrl, '_blank')
        return
      }
      window.open(location.website_url, '_blank')
    }
  }

  const handleContact = () => {
    if (location?.email) {
      window.location.href = `mailto:${location.email}`
    }
  }

  const handlePage = (newPage: number) => {
    dispatch(programActions.setCurrentPage(newPage))
  }

  return (
    <>
      {loading === 'loading' && !location ? (
        <PageLoader />
      ) : (
        <ExternalProgramContainer>
          <ExternalProgramItemContainer>
            <Text weight="bold" preset="h3">
              {location && location.name}
            </Text>
          </ExternalProgramItemContainer>

          {location && location.logo_url && (
            <FacilitiesCourtImageContainer>
              <FacilitiesCourtImage src={location.logo_url} />
            </FacilitiesCourtImageContainer>
          )}

          {location && (
            <ExternalProgramItemContainer>
              <FacilitiesAddress>{location.address}</FacilitiesAddress>
              <LocationIconContainer>
                <MdLocationOn />
              </LocationIconContainer>
            </ExternalProgramItemContainer>
          )}

          <ExternalProgramItemContainer>
            <Button
              preset={'ghost'}
              variant={'neutral'}
              text={'Contact'}
              size={'medium'}
              style={{ marginRight: '15px' }}
              onClick={handleContact}
            />

            <Button
              preset={'ghost'}
              variant={'neutral'}
              text={'Website'}
              size={'medium'}
              style={{ marginRight: '15px' }}
              onClick={handleRedirect}
            />
          </ExternalProgramItemContainer>

          {location && (
            <ExternalProgramItemContainer>
              <FacilitiesAddress>{location.description}</FacilitiesAddress>
            </ExternalProgramItemContainer>
          )}

          <FacilitiesCourtContainer>
            <Court
              qty={location ? location.courts.length : 0}
              title={'Regular Court Schedule'}
            />
          </FacilitiesCourtContainer>

          <div
            style={{
              width: '100%',
              justifyContent: 'center',
              display: 'flex',
              margin: '80px 0px',
            }}>
            <div style={{ minWidth: 1200 }}>
              <Input
                label={'Search'}
                placeholder="Program Name"
                required
                onChange={evt => setSearchText(evt.target.value)}
              />
              <Table
                styles={{ width: '100%', marginTop: 40 }}
                header={['Name', 'Option']}
                pagination
                loading={programStatus === 'loading' ? true : false}
                totalCount={totalPrograms}
                currentPage={currentPage}
                onChangePage={handlePage}>
                {programs &&
                  programs.length > 0 &&
                  programs.map(program => (
                    <ProgramItem
                      key={program.id}
                      program={program}
                      locationId={params.locationId}
                    />
                  ))}
              </Table>
            </div>
          </div>
        </ExternalProgramContainer>
      )}
    </>
  )
}

export default ExternalProgramPage
